import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import clazz from 'classnames';
import NestToast from '../NestToast';
import styled from 'styled-components'; // import tw from 'twin.macro'
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var StyledLayout = styled.div.withConfig({
    displayName: "Toast__StyledLayout",
    componentId: "sc-1makp3x-0"
})([
    "position:fixed;z-index:900;left:50%;top:10vh;transform:translate(-50%,-50%);.inner{min-width:100px;max-width:500px;z-index:999;display:flex;justify-content:center;}&.nest{position:absolute;left:0;top:0;width:100%;height:100%;z-index:800;}"
]);
export var Toast = /*#__PURE__*/ function(_PureComponent) {
    "use strict";
    _inherits(Toast, _PureComponent);
    var _super = _createSuper(Toast);
    function Toast() {
        _classCallCheck(this, Toast);
        var _this;
        _this = _super.apply(this, arguments);
        _this.state = {
            content: _this.props.content
        };
        _this.timer = null;
        _this.changeContent = function(content) {
            _this.setState({
                content: content
            });
        };
        _this.handler = function(e) {
            var // const target = e.target as HTMLDivElement
            // if (!target.closest('.ui-tiny-toast')) {
            ref, ref1;
            (ref = _this.props) === null || ref === void 0 ? void 0 : (ref1 = ref.outclick) === null || ref1 === void 0 ? void 0 : ref1.call(ref); // }
        };
        return _this;
    }
    _createClass(Toast, [
        {
            key: "tick",
            value: function tick() {
                var duration = this.props.duration;
                if (typeof duration !== 'undefined' && duration !== -1) {
                    var _this = this;
                    this.timer = setTimeout(function() {
                        var ref, ref2;
                        (ref = _this.props) === null || ref === void 0 ? void 0 : (ref2 = ref.onTimeEnd) === null || ref2 === void 0 ? void 0 : ref2.call(ref);
                    }, duration * 1000);
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.timer && clearTimeout(this.timer);
                document.body.removeEventListener('click', this.handler);
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.tick();
                document.body.addEventListener('click', this.handler, false);
            }
        },
        {
            key: "render",
            value: function render() {
                var content = this.state.content;
                var _props = this.props, left = _props.left, _nest = _props.nest, nest = _nest === void 0 ? false : _nest, type = _props.type, alpha = _props.alpha;
                var styles = left ? {
                    left: left
                } : undefined;
                return(/*#__PURE__*/ _jsx(StyledLayout, {
                    "data-role": "toast",
                    style: styles,
                    className: clazz([
                        {
                            nest: !!nest
                        }
                    ]),
                    children: /*#__PURE__*/ _jsx(NestToast, {
                        type: type,
                        className: "inner",
                        text: content,
                        alpha: alpha
                    })
                }));
            }
        }
    ]);
    return Toast;
}(React.PureComponent);
var theToast = null, container, theToastTimer;
var maker = function(duration) {
    return setTimeout(function() {
        destroy();
    }, duration * 1000);
};
var destroy = function() {
    if (container) {
        var ref;
        (ref = container.parentElement) === null || ref === void 0 ? void 0 : ref.removeChild(container);
    }
    theToast = null;
    container = null;
    document.body.removeEventListener('click', handler, false);
};
var handler = function(e) {
    var target = e.target; // if (!target.closest('.ui-tiny-toast')) {
    destroy(); // }
};
export default function toasty(props) {
    var _duration = props.duration, duration = _duration === void 0 ? 3 : _duration, _wrapper = props.wrapper, wrapper = _wrapper === void 0 ? document.querySelector('#page-sub-layout') || document.body : _wrapper, rest = _objectWithoutProperties(props, [
        "duration",
        "wrapper"
    ]);
    if (theToast) {
        theToast.changeContent(rest.content);
        theToastTimer && clearTimeout(theToastTimer);
        if (duration !== -1) {
            theToastTimer = maker(duration);
        }
        return theToast;
    }
    setTimeout(function() {
        container = document.createElement('div');
        wrapper.appendChild(container);
        ReactDOM.render(/*#__PURE__*/ _jsx(Toast, _objectSpread({}, rest)), container, function() {
            theToast = this;
        });
    }, 200);
    document.body.addEventListener('click', handler, false);
    if (duration !== -1) {
        theToastTimer = maker(duration);
    }
    return theToast; // return ReactDOM.createPortal(<Toast {...rest} />, document.body)
};
toasty.error = function(content) {
    toasty({
        content: content,
        type: 'error'
    });
};
